$(function() {
    var $drawerChk = $('#drawerCheckbox');
    var $body = $('body');
    var $header = $('.header');
    var $headerH;
    var $main = $('.main');
    var $gNav = $header.find('.navColumns');
    var $gNavOv = $header.find('.gnavToggle__overlay');
    /* -------------------------------------------------------------
     モバイル端末に切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToMobile = function() {
        $headerH = $header.outerHeight();
        $header.css({'position':'fixed'});
        $main.css({'margin-top':$headerH});
        $gNav.css({'padding-top':$headerH});
        $gNavOv.css({'top':$headerH});
        $drawerChk.prop('checked',false);
    };
    /* -------------------------------------------------------------
     PCに切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToPC = function() {
        $gNav.css({'padding-top':0});
        $header.css({'position':'fixed'});
        $drawerChk.prop('checked',false);
        $headerH = $header.outerHeight();
        $main.css({'margin-top':$headerH});
    };
    rwd.init();
    if (rwd.supported) {
        rwd.register('(min-width: 0) and (max-width: 979px)', switchingToMobile);
        rwd.register('(min-width: 980px)', switchingToPC);
        rwd.update();
    } else {
        switchingToPC();
    }
    /* -------------------------------------------------------------
     パスワードトグル
     ------------------------------------------------------------- */
    $('.ico__eye').on('click',function(){
       var $elm = $(this);
       var $input = $elm.prev('input');
       if($elm.hasClass('isShow')){
           $elm.removeClass('isShow');
           $input.attr('type','password').focus();
       }else {
           $elm.addClass('isShow');
           $input.attr('type','text').focus();
       }
    });
});